<template>
    <div id="privacy">
        <div class="panel-privacy">
            <h2 class="page-header">Vind de beste coach voor jou:<br>ontdek binnen 2 minuten je 6 beste matches.</h2>
            <div class="panel-text-container">
                <p>Om de 6 coaches te vinden die het best bij je passen, willen we je graag een aantal vragen stellen over waar je aan wil werken en wat je zoekt in een coach.</p>
            </div>

                <div class="buttons-container">
                    <next-button text="Start nu" :isValid="true" />
                </div>

        </div>
    </div>
</template>

<script>
    import NextButton from "../partials/NextButton";

    export default {
        name: 'Privacy',
        components: { NextButton }
    }
</script>